import getScrollbarWidth from './getScrollbarWidth';
import getOffset from './getOffset';
import TweenMax, { Power2 } from "gsap/TweenMax";

import lazyLoadInstances from "./LazyInstances";

class Gallery{
    constructor(container){
        this.container = container;
        this.scrollable = this.container.getElementsByClassName('j-gallery-scrollable')[0];
        this.prev = this.container.getElementsByClassName('j-gallery-prev')[0];
        this.next = this.container.getElementsByClassName('j-gallery-next')[0];
        this.photos = this.container.getElementsByClassName('j-photo-open');
        this.busy = false;

        this.init();
    }

    init(){
        const cmp = this;

        cmp.scrollable.style.height = `calc(100vh + ${getScrollbarWidth()}px)`;

        window.addEventListener('resize', function(){
            cmp.scrollable.style.height = `calc(100vh + ${getScrollbarWidth()}px)`;
        });

        document.addEventListener('gallery.toStart', function(){
            let w = parseFloat(Math.max(document.documentElement.clientWidth, window.innerWidth || 0),0);
            cmp.scrollable.scrollLeft = 0;            
            if(cmp.scrollable.scrollLeft === 0){
                cmp.prev.disabled = true;
            }
            else{
                cmp.prev.disabled = false;
            }
            if(parseInt(getOffset(cmp.photos[cmp.photos.length-1]).left,0) + parseInt(cmp.photos[cmp.photos.length-1].clientWidth) < cmp.scrollable.scrollLeft + w){
                cmp.next.disabled = true;
            }
            else{
                cmp.next.disabled = false;
            }
            cmp.next.disabled = false;
            cmp.busy = false;
        });

        cmp.prev.addEventListener('click', function(){
            if(!cmp.busy){
                console.log(cmp.scrollable.scrollLeft);
                let w = parseFloat(Math.max(document.documentElement.clientWidth, window.innerWidth || 0),0);
                cmp.busy = true;
                let target = Math.max(cmp.scrollable.scrollLeft-w,0);

                TweenMax.to(
                    `.j-gallery-scrollable`,
                    0.5,
                    {
                        scrollLeft: target,
                        ease: Power2.easeOut,
                        onComplete: () => {
                            if(cmp.scrollable.scrollLeft === 0){
                                cmp.prev.disabled = true;
                            }
                            else{
                                cmp.prev.disabled = false;
                            }
                            if(parseInt(getOffset(cmp.photos[cmp.photos.length-1]).left,0) + parseInt(cmp.photos[cmp.photos.length-1].clientWidth) < cmp.scrollable.scrollLeft + w){
                                cmp.next.disabled = true;
                            }
                            else{
                                cmp.next.disabled = false;
                            }
                            cmp.busy = false;
                        }
                    }
                );
            }
        });

        cmp.next.addEventListener('click', function(){
            if(!cmp.busy){
                console.log(cmp.scrollable.scrollLeft);
                let w = parseFloat(Math.max(document.documentElement.clientWidth, window.innerWidth || 0),0);
                let maxR = parseInt(getOffset(cmp.photos[cmp.photos.length-1]).left,0) + parseInt(cmp.photos[cmp.photos.length-1].clientWidth) + 128 - w;
                cmp.busy = true;
                let target = Math.min(cmp.scrollable.scrollLeft+w,maxR);

                TweenMax.to(
                    `.j-gallery-scrollable`,
                    0.5,
                    {
                        scrollLeft: target,
                        ease: Power2.easeOut,
                        onComplete: () => {
                            if(cmp.scrollable.scrollLeft === 0){
                                cmp.prev.disabled = true;
                            }
                            else{
                                cmp.prev.disabled = false;
                            }
                            if(parseInt(getOffset(cmp.photos[cmp.photos.length-1]).left,0) + parseInt(cmp.photos[cmp.photos.length-1].clientWidth) < cmp.scrollable.scrollLeft + w){
                                cmp.next.disabled = true;
                            }
                            else{
                                cmp.next.disabled = false;
                            }
                            cmp.busy = false;
                        }
                    }
                );
            }
        });

        /*cmp.scrollable.addEventListener('scroll', function(){
            console.log(lazyLoadInstances);
            for(let i=0; i<lazyLoadInstances.length; i++){
                lazyLoadInstances[i].update();
            }
        });*/
    }
}

export default Gallery;